import { unwrap } from '../intent-client.js';
export function createExchangeClient(transport) {
    return {
        async authorize(input, signal) {
            return unwrap(await transport.POST('/v1/onramp/exchanges/authorize', {
                body: input,
                ...(signal ? { signal } : {}),
            }));
        },
        async status(id, signal) {
            return unwrap(await transport.GET('/v1/onramp/exchanges/{id}/status', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
        async accounts(id, signal) {
            return unwrap(await transport.GET('/v1/onramp/exchanges/{id}/accounts', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            })).balances;
        },
        async prepare(id, input, signal) {
            return unwrap(await transport.POST('/v1/onramp/exchanges/{id}/review', {
                params: { path: { id } },
                body: input,
                ...(signal ? { signal } : {}),
            }));
        },
        async submit(id, reviewId) {
            return unwrap(await transport.POST('/v1/onramp/exchanges/{id}/withdraw', {
                params: { path: { id } },
                body: { reviewId },
            }));
        },
        async confirm(id, code) {
            return unwrap(await transport.POST('/v1/onramp/exchanges/{id}/confirm', {
                params: { path: { id } },
                body: { code },
            }));
        },
        async resend(id) {
            return unwrap(await transport.POST('/v1/onramp/exchanges/{id}/resend', {
                params: { path: { id } },
            }));
        },
    };
}
